"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NoItemsIndicator = _interopRequireDefault(require("../NoItemsIndicator"));
var _ItemListStyled = require("./ItemList-styled");
var _Pagination = _interopRequireDefault(require("../Pagination"));
var _ActionButtonList = _interopRequireDefault(require("../ActionButtonList"));
var _helper = require("../resources/helper");
var _Tooltip = _interopRequireDefault(require("calcite-react/Tooltip"));
var _Checkbox = _interopRequireDefault(require("calcite-react/Checkbox"));
var _MultiSelectActionToolbar = _interopRequireDefault(require("../MultiSelectActionToolbar"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helper2 = require("../../utils/helper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ItemList = function ItemList(_ref) {
  var queryResults = _ref.queryResults,
    handleQueryChange = _ref.handleQueryChange,
    singleItemActions = _ref.singleItemActions,
    actions = _ref.actions,
    session = _ref.session,
    itemBrowserState = _ref.itemBrowserState,
    getUserFolders = _ref.getUserFolders,
    customItemIdKey = _ref.customItemIdKey,
    browserView = _ref.browserView,
    portal = _ref.portal,
    singleSelect = _ref.singleSelect,
    selectedItemIds = _ref.selectedItemIds,
    setSelectedItemIds = _ref.setSelectedItemIds,
    _customTitleRenderer = _ref.customTitleRenderer,
    other = _objectWithoutProperties(_ref, ["queryResults", "handleQueryChange", "singleItemActions", "actions", "session", "itemBrowserState", "getUserFolders", "customItemIdKey", "browserView", "portal", "singleSelect", "selectedItemIds", "setSelectedItemIds", "customTitleRenderer"]);
  var itemIdentifier = customItemIdKey ? customItemIdKey : "id";
  (0, _react.useEffect)(function () {
    var _queryResults$results;
    var queryResultIds = queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$results = queryResults.results) === null || _queryResults$results === void 0 ? void 0 : _queryResults$results.map(function (result) {
      return result[itemIdentifier];
    });
    var filteredQueryResultIds = queryResultIds === null || queryResultIds === void 0 ? void 0 : queryResultIds.filter(function (resultId) {
      return selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.includes(resultId);
    });
    if ((filteredQueryResultIds === null || filteredQueryResultIds === void 0 ? void 0 : filteredQueryResultIds.join()) !== (selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.join())) {
      setSelectedItemIds(filteredQueryResultIds);
    }
  }, [customItemIdKey, itemIdentifier, queryResults, selectedItemIds, setSelectedItemIds]);
  var clearSelectedItems = function clearSelectedItems() {
    setSelectedItemIds([]);
  };
  var handleItemClick = function handleItemClick(itemId) {
    if (!singleSelect) {
      if (isSelected(itemId)) {
        setSelectedItemIds(selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.filter(function (item) {
          return item !== itemId;
        }));
      } else {
        setSelectedItemIds([].concat(_toConsumableArray(selectedItemIds), [itemId]));
      }
    } else {
      if (isSelected(itemId)) {
        setSelectedItemIds([]);
      } else {
        setSelectedItemIds([itemId]);
      }
    }
  };
  var isSelected = function isSelected(itemId) {
    return selectedItemIds === null || selectedItemIds === void 0 ? void 0 : selectedItemIds.includes(itemId);
  };
  var getMenuLocationTitle = function getMenuLocationTitle() {
    switch (browserView) {
      case "content":
        var selectedFolder = (0, _helper2.getSelectedFolder)(itemBrowserState);
        return selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.title;
      default:
        return _helper2.browserViewTitles[browserView] || "results";
    }
  };
  return (queryResults === null || queryResults === void 0 ? void 0 : queryResults.total) ? /*#__PURE__*/_react.default.createElement("div", null, actions && /*#__PURE__*/_react.default.createElement(_MultiSelectActionToolbar.default, {
    queryResults: queryResults,
    items: selectedItemIds,
    actions: actions,
    clearSelectedItems: clearSelectedItems,
    userSession: session,
    handleQueryChange: handleQueryChange,
    itemBrowserState: itemBrowserState,
    getUserFolders: getUserFolders,
    menuLocationTitle: getMenuLocationTitle()
  }), /*#__PURE__*/_react.default.createElement(_ItemListStyled.StyledItemList, other, queryResults.results.map(function (item) {
    var sharingIcons = (0, _helper.getSharingIcons)({
      item: item
    });
    var style = {};
    if (isSelected(item.id)) {
      style = {
        boxShadow: "0 0 0 1px #0079c1, 0 0 16px 0 rgb(0 0 0 / 0%)"
      };
    }
    if (!(item === null || item === void 0 ? void 0 : item.created)) {
      item.created = item === null || item === void 0 ? void 0 : item.uploaded;
    }
    return /*#__PURE__*/_react.default.createElement(_ItemListStyled.CardContainer, {
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: isSelected(item.id),
      onClick: function onClick() {
        return handleItemClick(item.id);
      }
    }), /*#__PURE__*/_react.default.createElement(_ItemListStyled.StyledItemCard, {
      style: style,
      item: item,
      portal: portal,
      token: session._token,
      maxDescriptionLength: 180,
      defaultThumbnailUrl: "https://static.arcgis.com/images/desktopapp.png",
      customTitleRenderer: function customTitleRenderer(title) {
        if (_customTitleRenderer) {
          return _customTitleRenderer(title, item);
        } else {
          return /*#__PURE__*/_react.default.createElement(_ItemListStyled.StyledItemCardTitle, {
            target: "_blank",
            href: (0, _helper2.getItemOrgPageUrl)(portal, item.id)
          }, title);
        }
      },
      actions: [(0, _helper.getItemTypeIcon)(item, {
        margin: "auto auto auto 0",
        minWidth: "16px",
        padding: "0"
      }), /*#__PURE__*/_react.default.createElement(_ItemListStyled.StyledShareIcons, {
        key: "share"
      }, sharingIcons.map(function (icon) {
        return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
          key: icon.id,
          title: icon.label
        }, icon.icon);
      })), /*#__PURE__*/_react.default.createElement(_ActionButtonList.default, {
        key: "actions",
        actions: singleItemActions,
        collapsed: true,
        itemId: item.id,
        visibleActionsCount: 1
      })]
    }));
  })), queryResults && (queryResults === null || queryResults === void 0 ? void 0 : queryResults.total) > (queryResults === null || queryResults === void 0 ? void 0 : queryResults.num) && /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    handleQueryChange: handleQueryChange,
    clearSelectedItems: clearSelectedItems,
    queryResults: queryResults
  })) : /*#__PURE__*/_react.default.createElement(_NoItemsIndicator.default, null);
};
ItemList.propTypes = {
  actions: _propTypes.default.array,
  singleItemActions: _propTypes.default.array,
  session: _propTypes.default.object,
  handleQueryChange: _propTypes.default.func,
  itemBrowserState: _propTypes.default.object.isRequired
};
var _default = ItemList;
exports.default = _default;